/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOccupationMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateOccupationInput;
}>;


export type UpdateOccupationMutation = { __typename?: 'Mutation', updateOccupation: { __typename?: 'Occupation', id: string, annualIncomeBeforeCompany: number | null, atLeast30HoursAWeek: boolean | null, becameOwnerAt: string | null, companyFoundedAt: string | null, corporateStructure: string | null, disabilityInsuranceSource: string | null, disabilityInsuranceStatus: boolean | null, educationLevel: string | null, employerPaysPremium: boolean | null, existingCoverage: number | null, governmentEmployee: boolean | null, individualIncome: number | null, intendToReplace: boolean | null, numberOfEmployees: number | null, numberOfPartners: number | null, ownershipStake: number | null, selfEmployed: boolean | null, workFromHomePercentage: number | null, yearsOfExperience: number | null, job: { __typename?: 'Job', id: string, title: string, group: string } | null } | null };


export const UpdateOccupationDocument = gql`
    mutation UpdateOccupation($input: UpdateOccupationInput!) {
  updateOccupation(input: $input) {
    id
    annualIncomeBeforeCompany
    atLeast30HoursAWeek
    becameOwnerAt
    companyFoundedAt
    corporateStructure
    disabilityInsuranceSource
    disabilityInsuranceStatus
    educationLevel
    employerPaysPremium
    existingCoverage
    governmentEmployee
    individualIncome
    intendToReplace
    job {
      id
      title
      group
    }
    numberOfEmployees
    numberOfPartners
    ownershipStake
    selfEmployed
    workFromHomePercentage
    yearsOfExperience
  }
}
    `;
export type UpdateOccupationMutationFn = Apollo.MutationFunction<UpdateOccupationMutation, UpdateOccupationMutationVariables>;
export function useUpdateOccupationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOccupationMutation, UpdateOccupationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOccupationMutation, UpdateOccupationMutationVariables>(UpdateOccupationDocument, options);
      }
export type UpdateOccupationMutationHookResult = ReturnType<typeof useUpdateOccupationMutation>;
export type UpdateOccupationMutationResult = Apollo.MutationResult<UpdateOccupationMutation>;
export type UpdateOccupationMutationOptions = Apollo.BaseMutationOptions<UpdateOccupationMutation, UpdateOccupationMutationVariables>;